import { CONSTANTS } from '@/types/enum/constants'

const getIsUserAdminInsightBackOffice = (loggedUserRoles: string[]): boolean =>
  !!loggedUserRoles.find(
    value =>
      CONSTANTS.ROLE_DYNAMIC_ROUTE_PHARMEDICALL_ADMIN === value ||
      CONSTANTS.ROLE_DYNAMIC_ROUTE_INSIGHT_ADMIN == value
  ) || false

export default getIsUserAdminInsightBackOffice
